import React from "react";
import { Col, FormGroup, Row } from "shards-react";
import AdviceText from "../../../advice-text-component/AdviceText";
import { Label } from "./style";

const elementWithAllText = BaseInputComponent => props => {
    const element = (
        <FormGroup key={props.id} id={props.id || props.name}>
            <Label>{props.label}</Label>
            <AdviceText
                showerror={props.showerror}
                text={props.advicetext}
                color={"#8C0E0E"}
            />
            <Row>
                <Col sm={12} md={6} lg={6}>
                    <BaseInputComponent {...props} />
                </Col>
                <Col sm={12} md={6} lg={6}>
                    <div className="h-100 w-100 d-flex align-items-center">
                        <p className="m-0">{props.helptext}</p>
                    </div>
                </Col>
            </Row>
        </FormGroup>
    );
    return element;
};

export default elementWithAllText;
